var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VxCurrencyInput',{staticClass:"input-text-border-none input11 input-text-border-none align-left",class:_vm.textAlign,on:{"blur":_vm.changeInput,"click":_vm.onClick},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }